<template>
  <div :ref="ename" class="ec"></div>
</template>
    
    <script>
import { fontSize } from "@/js/utils";
const colorList = [
  "#47A2FF ",
  "#53C8D1",
  "#59CB74",
  "#FBD444",
  "#7F6AAD",
  "#585247",
];

var numMap = {};

export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ename: {
      type: String,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    onclick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myChart: "",
      list: [],
      option: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: "10%",
          top: "center",
          itemGap: 10,
          selectedMode: false,
          icon: "pin",
          data: [],
          textStyle: {
            color: "#77899c",
            rich: {
              uname: {
                width: 100,
              },
              unum: {
                width: 100,
                color: "#4ed139",
              },
            },
          },
          formatter(name) {
            return `{uname|${name}}{unum|${numMap[name]}}`;
          },
        },
        color: colorList,
        series: [
          {
            name: "",
            type: "pie",
            // silent: true, //取消高亮
            radius: ["60%", "80%"],
            center: ["30%", "50%"],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                borderWidth: 5,
                borderColor: "transparent",
              },
            },
            data: [],
          },
        ],
      },
    };
  },
  computed: {
    full() {
      return this.$store.state.menuShow;
    },
  },
  watch: {
    full(newval) {
      this.myChart.resize();
    },
    data: {
      handler(newVal) {
        if (newVal && this.myChart != "") {
          this.list = newVal;
          this.updateOption();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getEchartData();
    window.addEventListener("resize", this.myChart.resize);
  },
  beforeDestroy() {
    // 移除窗口改变监听
    this.onclick && this.myChart.off("click", this.getClickInfo);
    window.removeEventListener("resize", this.myChart.resize);
  },
  methods: {
    getClickInfo(e) {
      this.$emit("click", e);
    },
    updateOption() {
      this.handlerData();
      this.myChart.setOption(this.option);
    },
    handlerData() {
      let obj = {};
      this.data.forEach((item) => {
        obj[item.name] = item.value;
      });
      numMap = obj;
      this.option.series[0].data = this.data;
      this.option.legend.data = this.data.map((item) => item.name);
    },
    getEchartData() {
      this.handlerData();
      const chart = this.$refs[this.ename];
      if (chart) {
        this.myChart = this.$echarts.init(chart);
        this.myChart.setOption(this.option);
        this.onclick && this.myChart.on("click", this.getClickInfo);
      }
    },
  },
};
</script>
    
    <style lang="less" scoped>
.ec {
  width: 100%;
  height: 100%;
}
</style>